import styled from 'styled-components';
import { colors, spacing, breakpoints } from '../../../constants/theme';

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${spacing.md};
`;

export const Header = styled.div`
  padding: ${spacing.lg} 0 ${spacing.md};
  text-align: center;
  
  @media (max-width: ${breakpoints.tablet}) {
    padding: ${spacing.md} 0 ${spacing.sm};
  }
  
  @media (max-width: ${breakpoints.mobile}) {
    padding: ${spacing.sm} 0 ${spacing.xs};
  }
`;

export const Title = styled.h1`
  color: ${colors.text.primary};
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: ${spacing.sm};
  background: linear-gradient(135deg, ${colors.primary.main}, ${colors.primary.light});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  
  @media (max-width: ${breakpoints.tablet}) {
    font-size: 2rem;
  }
  
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 1.8rem;
  }
`;

export const Description = styled.p`
  color: ${colors.text.secondary};
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
  
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 1rem;
  }
`;

// ...existing code...

export const TabContainer = styled.div`
  background: ${colors.background.secondary};
  border-radius: 16px;
  padding: ${spacing.sm};
  margin-bottom: ${spacing.md};
  border: 1px solid ${colors.background.tertiary};
  
  @media (max-width: ${breakpoints.mobile}) {
    padding: ${spacing.xs};
    margin-bottom: ${spacing.sm};
    border-radius: 12px;
  }
`;

export const TabNavigation = styled.div`
  display: flex;
  gap: ${spacing.xs};
  margin-bottom: ${spacing.md};
  
  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    gap: ${spacing.xs};
    margin-bottom: ${spacing.sm};
  }
`;

export const TabButton = styled.button<{ $active: boolean }>`
  padding: ${spacing.md} ${spacing.lg};
  background: ${props => props.$active ? colors.primary.main : 'transparent'};
  color: ${props => props.$active ? colors.background.primary : colors.text.secondary};
  border: 1px solid ${props => props.$active ? colors.primary.main : colors.background.tertiary};
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: ${spacing.sm};
  flex: 1;
  justify-content: center;
  
  &:hover {
    background: ${props => props.$active ? colors.primary.dark : colors.background.tertiary};
    color: ${props => props.$active ? colors.background.primary : colors.text.primary};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px ${props => props.$active ? colors.primary.main : colors.background.tertiary}30;
  }
  
  @media (max-width: ${breakpoints.mobile}) {
    padding: ${spacing.sm} ${spacing.md};
    font-size: 13px;
  }
`;

export const TabIcon = styled.span`
  font-size: 16px;
  
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 14px;
  }
`;

export const TabContent = styled.div`
  min-height: 400px;
  
  @media (max-width: ${breakpoints.tablet}) {
    min-height: 300px;
  }
`;

export const ContentArea = styled.div`
  background: ${colors.background.primary};
  border-radius: 12px;
  padding: ${spacing.lg};
  border: 1px solid ${colors.background.tertiary};
  
  @media (max-width: ${breakpoints.tablet}) {
    padding: ${spacing.md};
  }
  
  @media (max-width: ${breakpoints.mobile}) {
    padding: ${spacing.sm};
  }
`;

// User Management Styles
export const UserList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
  margin-top: ${spacing.lg};
`;

export const UserCard = styled.div<{ $isActive: boolean }>`
  background: ${colors.background.secondary};
  border: 1px solid ${props => props.$isActive ? colors.text.disabled : colors.text.hint};
  border-radius: 12px;
  padding: ${spacing.lg};
  transition: all 0.2s ease;
  opacity: ${props => props.$isActive ? 1 : 0.7};
  
  &:hover {
    border-color: ${colors.primary.light};
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.15);
  }
`;

export const UserInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${spacing.md};
  
  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const UserDetails = styled.div`
  flex: 1;
`;

export const UserName = styled.h3`
  color: ${colors.text.primary};
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 ${spacing.xs};
`;

export const UserEmail = styled.p`
  color: ${colors.text.secondary};
  font-size: 1rem;
  margin: 0;
`;

export const UserRole = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.sm};
`;

export const RoleSelect = styled.select`
  background: ${colors.background.primary};
  border: 1px solid ${colors.text.disabled};
  border-radius: 8px;
  padding: ${spacing.sm} ${spacing.md};
  color: ${colors.text.primary};
  font-size: 0.9rem;
  min-width: 120px;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: ${colors.primary.main};
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ActionButton = styled.button<{ variant?: 'primary' | 'secondary' }>`
  background: ${props => props.variant === 'secondary' ? colors.background.tertiary : colors.primary.main};
  color: ${props => props.variant === 'secondary' ? colors.text.secondary : colors.text.primary};
  border: 1px solid ${props => props.variant === 'secondary' ? colors.text.disabled : colors.primary.main};
  border-radius: 8px;
  padding: ${spacing.sm} ${spacing.md};
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background: ${props => props.variant === 'secondary' ? colors.background.secondary : colors.primary.dark};
    transform: translateY(-1px);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: ${spacing.xl};
  color: ${colors.text.secondary};
  
  p {
    font-size: 1.1rem;
    margin: 0;
  }
`;

export const LoadingSpinner = styled.div`
  text-align: center;
  padding: ${spacing.xl};
  color: ${colors.text.secondary};
  font-size: 1.1rem;
`;

// Tab Section Styles
export const TabSection = styled.div`
  padding: ${spacing.lg};
`;

export const SectionTitle = styled.h2`
  color: ${colors.text.primary};
  font-size: 1.8rem;
  font-weight: 600;
  margin: 0 0 ${spacing.sm};
  background: linear-gradient(135deg, ${colors.primary.main}, ${colors.secondary.main});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const SectionDescription = styled.p`
  color: ${colors.text.secondary};
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 0 ${spacing.lg};
  max-width: 800px;
`;
